<template>
  <div class="user-detail container-fluid">
    <div v-show="isLoading">
      <LoadingOverlay :show="isLoading" title="Caricamento quesiti" :message="loadingMessage" />
    </div>
    <h1 class="mb-4">I miei dati</h1>

    <div v-if="user" class="row">
      <!-- Colonna sinistra: etichette -->
      <div class="col-12 col-md-6 labels">
        <ul class="list-unstyled">
          <li>Nome</li>
          <li>Cognome</li>
          <li>Codice fiscale</li>
          <!--<li>Ruolo</li>-->
          <li>Nome dell'Ente</li>
          <li>Codice Ente</li>
          <li>Regione/Provincia autonoma di riferimento</li>
          <!--<li>Ruolo ricoperto all'interno dell'Ente</li>-->
          <li>Email istituzionale (NO Pec)</li>
          <li>Recapito telefonico dell'ufficio</li>
          <li>Comune di residenza</li>
        </ul>
      </div>

      <!-- Colonna destra: valori -->
      <div class="col-12 col-md-6 values">
        <ul class="list-unstyled">
          <li>{{ user.name || '—' }}</li>
          <li>{{ user.surname || '—' }}</li>
          <li>{{ user.fiscalcode || '—' }}</li>
          <!--<li>{{ user.roles[0]?.description || '—' }}</li>-->
          <li>{{ user.organization || '—' }}</li>
          <li>{{ organizationCode }}</li>
          <li>{{ user.region_name || '—' }}</li>
          <!--<li>{{ user.roles.name || '—' }}</li>-->
          <li>{{ user.email || '—' }}</li>
          <li>{{ user.phone || '—' }}</li>
          <li>{{ user.comune || '—' }}</li>
        </ul>
      </div>
    </div>

    <div v-else>Caricamento...</div>
  </div>
</template>

<script>
import ToastDialog from '../../../components/common/ToastDialog.vue'
import BreadcrumbElement from '../../../components/common/BreadcrumbElement.vue'
import toastable from '../../../mixins/toastable'
import LoadingOverlay from '../../partials/LoadingOverlay.vue';

export default {
  name: 'UserDetailView',
  mixins: [toastable],
  components: {
    ToastDialog,
    BreadcrumbElement,
    LoadingOverlay
  },
  data() {
    return {
      user: null,
      currentUser: this.$root.user,
      errors: null,
      isLoading: true,
    }
  },
  computed: {
    isSuperAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles?.some(r => r.name === 'Super Admin')
      )
    },
    organizationCode() {
      return this.user.organization_fiscal_code
        ?? this.user.cod_amm?.toUpperCase()
        ?? '—';
    }

  },
  async mounted() {
    try {
      this.isLoading = true;
      const response = await this.$root.$api.get(`/users/${this.currentUser.sub}`)
      this.user = response.data
      this.isLoading = false;
    } catch (error) {
      this.showErrorToast('Errore', 'Impossibile caricare i dati utente')
      console.error(error)
    }
  },
  methods: {
    showErrorToast(title, message) {
      this.toastError = true
      this.toastTitle = title
      this.toastMessage = message
    }
  }
}
</script>

<style scoped>
.user-detail {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.labels li,
.values li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.labels li:last-child,
.values li:last-child {
  border-bottom: none;
}

.labels li {
  font-weight: 600;
  color: #444;
}

.values li {
  color: #222;
  word-break: break-word;
}

@media (min-width: 576px) {

  h1,
  .h1 {
    font-size: 2rem !important;
    line-height: 3.5rem !important;
  }
}
</style>